var $j = $j || jQuery.noConflict();
function bq_show_new_thread(){
    $j('#new-thread-box').addClass('active');
    $j('#new-thread-box textarea').focus();
}
function bq_show_reply(comment_id){
    $j('#reply-box-'+comment_id).addClass('active');
    $j('#reply-box-'+comment_id+' textarea').focus();
}
function bq_new_thread(data, url){
    var $field      = $j('#'+data.parentFieldId + ' #new-thread-text');
    var $formGroup  = $field.closest('.form-group');
    var text        = $field.val();
    var button      = $j('.btn', $formGroup);

    if (text.length == 0){
        alert('Comment can not be empty');
        return;
    } else if( $formGroup.hasClass('has-error') ) { // validation check
        return;
    }

    bq_lock_comments(null, button, true);

    data.comment = text;
    var type = $j('#'+data.parentFieldId).find('select[name=comment_type]');
    if (type.length) {
        data.comment_type = type.val();
    }
    $j.ajax(url, {
        data: data
    })
        .done(function(response){bq_new_comment_reply_after(response, data);})
        .fail(function(){})
        .always(function(){bq_unlock_comments(null, button, false);});

}
function bq_comment_reply(data, url) {
    var button = $j('#comment-reply-' + data.parent_comment_id).next().find('.btn');
    var text = $j('#reply-to-'+data.parent_comment_id).val();
    if (text.length == 0){
        alert('Reply can not be empty');
        return;
    }
    data.comment = text;
    /**
     * data
     *      id int record_id
     *      parent int comment_id
     *      comment text comment text
     */
    bq_lock_comments(data.parent_comment_id, button, true);
    $j.ajax(url, {
        data: data
    })
        .done(function(response){bq_comment_reply_after(response, data.parent_comment_id);})
        .fail(function(){})
        .always(function(){bq_unlock_comments(data.parent_comment_id,  button, false);});
}

function bq_comment_reply_after(response, comment_id){
    $j('#comment-box-'+comment_id).replaceWith(response);
}

function bq_new_comment_reply_after(response, config){
    $j('#'+config.parentFieldId).replaceWith(response);
}

function bq_lock_comments(comment_id, button, state){
    if(comment_id === null){
        $j('.comment-block').addClass('loading');
    }
    else {
        $j('#comment-box-'+comment_id).addClass('loading');
    }
    $j(button).prop('disabled', state);
}
function bq_unlock_comments(comment_id, button, state){
    if(comment_id === null){
        $j('.comment-block').removeClass('loading');
    }
    else {
        $j('#comment-box-'+comment_id).removeClass('loading');
    }
    $j(button).prop('disabled', state);
}
